import { render, staticRenderFns } from "./ChildrenDetailsStep.component.vue?vue&type=template&id=2d1ebe88&scoped=true&"
import script from "./ChildrenDetailsStep.component.vue?vue&type=script&lang=ts&"
export * from "./ChildrenDetailsStep.component.vue?vue&type=script&lang=ts&"
import style0 from "./ChildrenDetailsStep.component.vue?vue&type=style&index=0&id=2d1ebe88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1ebe88",
  null
  
)

export default component.exports